// Sets document.title — the replacement for Next's `export const metadata`.
//
// A static SPA has one index.html, so the title is set at runtime per route.
// Purely cosmetic (the browser tab and the bookmark name), but it's what made
// each page feel like its own place.

import { useEffect } from "react";

const SUFFIX = "A Nossa História";

export function useTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${SUFFIX}` : SUFFIX;
  }, [title]);
}
